<script>
import ScrollableContent from '@/views/ScrollableContent'
import UsersServices from '@/services/users'
import EnvironmentUtils from '@/utils/environmentUtils'
import DateUtils from '@/utils/dateUtils'
import StringUtils from '@/utils/stringUtils'
import GeolocationUtils from '@/utils/geolocationUtils'
import Button from '@/components/Button'
import WideIconTile from '@/components/WideIconTile'
import StoreNotificationElement from '@/components/StoreNotificationElement'
import StoreFrame from '@/frames/storeFrame'

export default
{
    name: 'store-page',

    created ()
    {
        StoreFrame.initFrame(this.$store)
    },

    render ()
    {
        const iconItems =
        [
            <inline-svg fill='white' src={require('@/assets/img/heart.svg')} 
                on-click={this.onHeartIconClicked} id='heart' add-class={this.isSavedAsFavorite ? 'active' : ''} />
        ]

        return (
            <div id='store-page-view'>
                <scrollable-content background-image={this.store.pictures[0]} icon-items={iconItems} back-path='/stores'>
                    <div id='title'>{this.store.name}</div>
                    <div domPropsInnerHTML={this.store.description} />
                    {
                        this.store.openHours && this.store.openHours.filter(d => d).length > 0 &&
                        <div>
                            <div class='section-separator' />
                            <div class='section-title'>Heures d'ouverture</div>
                            {
                                (() =>
                                {
                                    const today = this.store.openHours[new Date().getDay() - 1]
                                    var isOpen = false
                                    if (today)
                                    {
                                        const tdyStr = new Date().toDateString()
                                        
                                        
                                        const isInHours = hours => hours && new Date(tdyStr + ' ' + hours[0]) <= new Date() && new Date() <= new Date(tdyStr + ' ' + hours[1])
                                        if (isInHours(today.morning) || isInHours(today.afternoon)) isOpen = true
                                    }
                                    
                                    return <div class='store-state row'>
                                        {this.store.name} est <div class={`${isOpen ? 'is-open' : 'is-closed'}`}>{isOpen ? 'ouvert' : 'fermé'}</div>.
                                    </div>
                                })()
                            }
                            {
                                this.store.openHours.map((d, idx) =>
                                {
                                    const isToday = new Date().getDay() - 1 == idx

                                    if (!isToday && !this.showAllOpenHours) return

                                    var hours = <div>Fermé</div>
                                    if (d)
                                    {
                                        hours = <div class='column'>
                                            <div v-show={d.morning[0]}>{d.morning[0]} — {d.morning[1]}</div>
                                            <div v-show={d.afternoon[0]}>{d.afternoon[0]} — {d.afternoon[1]}</div>
                                        </div>
                                    }

                                    return <div class={`row day-open-hours ${this.showAllOpenHours ? 'show-all': ''} ${isToday ? 'is-today' : ''}`}>
                                        <div class='weekday'>{DateUtils.days.fr[idx]}</div>
                                        {hours}
                                    </div>
                                })
                            }
                            <Button v-show={!this.showAllOpenHours} class='show-more-day-hours-button' text='Voir plus' type='light'
                                icon={require('@/assets/img/back-thick.svg')} on-click={() => this.showAllOpenHours = true} />
                        </div>
                    }
                    {
                        this.store.address &&
                        <div>
                            <div class='section-separator' />
                            <div class='section-title'>Adresse</div>
                            <div class='store-address'>{StringUtils.formatAddress(this.store.address)}</div>
                            <Button type='text' class='open-maps-button' icon={require('@/assets/img/pin.svg')} text='Voir sur Google Maps'
                                on-click={()=>window.open(GeolocationUtils.generateGoogleMapLinkFromAddress(this.store.address), '_system')} />
                        </div>
                    }
                    {
                        (this.store.phone || this.store.email) &&
                        <div>
                            <div class='section-separator' />
                            <div class='section-title'>Contact</div>
                            {
                                StringUtils.extractPhoneNumbers(this.store.phone).map(num =>
                                {
                                    return <div class='row phone-number'>
                                        <div>Tél : {StringUtils.formatPhoneNumber(num)}</div>
                                        <Button type='text' class='action-button' icon={require('@/assets/img/call.svg')} text='Appeler'
                                           on-click={()=>window.open('tel://' + num, '_system')} />
                                    </div>
                                })
                            }
                            {
                                this.store.email &&
                                <div class='row'>
                                    <div>Mél : {this.store.email}</div>
                                    <Button type='text' class='action-button' icon={require('@/assets/img/envelope.svg')} text='Écrire'
                                       on-click={()=>window.open('mailto://' + this.store.email, '_system')} />
                                </div>
                            }
                        </div>
                    }
                    <div class='section-separator' />
                    <div class='section-title'>Photos</div>
                    <div class='store-pictures'>
                    {
                        this.store.pictures.map(p =>
                        {
                            return <img src={p} />
                        })
                    }
                    </div>
                    {
                        this.store.website &&
                        <div>
                            <div class='section-separator' />
                            <div class='section-title'>Site web</div>
                            <a target='_system' href={this.store.website}>{this.store.website.replace(/https?:\/\//, '')}</a>
                        </div>
                    }
                    {
                        this.storeNotifications.length > 0 &&
                        <div class='store-notifications' id='notifications'>
                            <div class='section-separator' />
                            <div class='section-title'>Dernières communications</div>
                            {
                                this.storeNotifications.map(notif =>
                                {
                                    return <store-notification-element notification-id={notif.id} id={`notification-${notif.id}`} />
                                })
                            }
                        </div>
                    }
                </scrollable-content>
            </div>
        )
    },

    data () 
    {
        return {
            showAllOpenHours: false
        }
    },

    computed:
    {
        storeId ()
        {
            const fromRoute = this.$route.params.id
            if (fromRoute) return fromRoute
        },

        store ()
        {
            return this.$store.getters.stores.getStoreById(this.storeId)
        },

        storeNotifications ()
        {
            return this.$store.getters.storeNotifications.getNotificationsByStoreId(this.storeId)
        },

        isSavedAsFavorite ()
        {
            return this.$store.state.favorites.stores.includes(this.store.id)
        }
    },

    mounted ()
    {
    },

    methods:
    {
        onHeartIconClicked (e)
        {
            this.$store.commit('favorites/setStoreState', {storeId: this.store.id, isFavorite: !this.isSavedAsFavorite})
            const subscribedToStoreIds = this.$store.state.favorites.stores
            UsersServices.updateUser(EnvironmentUtils.cityId, {tags: {subscribedToStoreIds}})
        },
    },

    components:
    {
        ScrollableContent,
        Button,
        WideIconTile,
        StoreNotificationElement
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#store-page-view
{
    #scrollable-content-view #backgroud-image-filter #scrollable-card #content #card-text
    {
        .section-separator
        {
            width: -webkit-fill-available-content;
            border-bottom: 1px solid var(--theme-border-color);
            margin: 15px 0;
        }

        .section-title
        {
            margin-bottom: 15px;
            color: var(--theme-text-color);
            font-weight: 700;
        }

        .row
        {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }

        .column
        {
            display: flex;
            flex-direction: column;
        }

        .store-state
        {
            justify-content: flex-start;
            white-space: break-spaces;
            margin-bottom: 10px;

            .is-open
            {
                font-weight: bold;
                color: var(--theme-success-color);
                display: contents;
            }

            .is-closed
            {
                font-weight: bold;
                color: var(--theme-danger-color);
                display: contents;
            }
        }

        .day-open-hours
        {
            &:not(:first-of-type)
            {
                margin-top: 10px;
            }

            &.is-today.show-all
            {
                font-weight: bold;
            }

            .weekday
            {
                margin-bottom: auto;
                .CapitalizeFirstLetter();
            }
        }

        .show-more-day-hours-button
        {
            width: -webkit-fill-available;
            margin-top: 10px;

            .icon
            {
                transform: rotate(-90deg);
            }
        }

        .store-address
        {
            white-space: pre-wrap;
        }

        .row.phone-number
        {
            &:not(:first-of-type)
            {
                margin-top: 5px;
            }
        }

        .open-maps-button
        {
            margin-top: 10px;
        }

        .action-button
        {
            padding: 0px 14px;
        }

        .store-pictures
        {
            display: flex;
            flex-direction: row;
            max-height: 150px;
            overflow-x: scroll;

            &::-webkit-scrollbar
            {
                .OnTabletAndLess({ display: none; })
            }

            img
            {
                object-fit: cover;
                border-radius: 10px;
                max-width: 200px;

                &:not(:last-of-type)
                {
                    margin-right: 10px;
                }
            }
        }
        
        .store-notifications
        {
            .wide-icon-tile
            {
                background-color: var(--theme-background-color);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/StorePage.vue